import { useCallback } from 'react';
import { useToken } from './useToken';
import axios from 'axios';
import { Role } from './useAdminRoleList';


type UseAdminUserRolesHookType = () => (id: number) => Promise<Role[]>

export const useAdminUserRoles: UseAdminUserRolesHookType = () => {

  const token = useToken()

  return useCallback(async (id) => {
    const {data} = await axios.get<Role[]>(
      `${process.env.REACT_APP_SERVER_URL}/users/${id.toString()}/roles`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
    )
    return data
  }, [token])
}